import { markdownButtonGroup } from '@squareup/dex-ui-shared-markdown-components';
import React, { FC, PropsWithChildren } from 'react';

interface MdxMarkdownButtonGroupProps {
  primaryButtonText: string;
  secondaryButtonText: string;
  primaryHref: string;
  secondaryHref: string;
}

const MdxMarkdownButtonGroup: FC<
  PropsWithChildren<MdxMarkdownButtonGroupProps>
> = (props) => {
  const Component = markdownButtonGroup.component
    .value as FC<MdxMarkdownButtonGroupProps>;
  return <Component {...props} />;
};

MdxMarkdownButtonGroup.displayName = 'MdxMarkdownButtonGroup';

export { MdxMarkdownButtonGroup };
